import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import './styles.css';

export default function FormModalSecteur({ onClose, refresh, secteurToUpdate = null }) {
    const [labelSecteur, setLabelSecteur] = useState("");
    const [iconFileSecteur, setIconFileSecteur] = useState(null);
    const [iconPreview, setIconPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        if (secteurToUpdate) {
            setLabelSecteur(secteurToUpdate.labelSecteur || "");

            if (secteurToUpdate.iconService) {
                setIconPreview(`${apiUrl}/api/files/?categorie=secteurs&file=${secteurToUpdate.iconSecteur}`);
            }
        }
    }, [secteurToUpdate, apiUrl]);

    const handleIconChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setIconFileSecteur(file);
            const reader = new FileReader();
            reader.onloadend = () => setIconPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("labelSecteur", labelSecteur);
        if (iconFileSecteur) formData.append("iconSecteur", iconFileSecteur);

        // 🔁 Ajoute _method=PUT pour simuler une mise à jour
        const isUpdate = !!secteurToUpdate;
        if (isUpdate) {
            formData.append("_method", "PUT");
        }

        try {
            const url = isUpdate
                ? `${apiUrl}/api/secteurs/${secteurToUpdate.idSecteur}`
                : `${apiUrl}/api/secteurs/`;

            const response = await fetch(url, {
                method: "POST", // ⚠️ Toujours POST même pour les updates
                headers: {
                    Authorization: "Bearer " + token,
                    // Ne pas mettre "Content-Type", sinon le navigateur ne gère pas le boundary automatiquement
                },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de l’enregistrement du secteur.");
            }

            alert(data.message || (isUpdate ? "Secteur modifié." : "Secteur ajouté."));
            refresh();
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <button className="modal-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <h2>{secteurToUpdate ? "Modifier un secteur d'activité" : "Ajouter un secteur d'activité"}</h2>
                <form onSubmit={handleSubmit}>


                    <label>
                        Nom du secteur :
                        <input
                            type="text"
                            value={labelSecteur}
                            onChange={(e) => setLabelSecteur(e.target.value)}
                            required
                        />
                    </label>


                    <label>
                        Icône :
                        <input type="file" accept="image/*" onChange={handleIconChange} />
                    </label>

                    {iconPreview && (
                        <div style={{ marginTop: "10px" }}>
                            <strong>Aperçu :</strong>
                            <div>
                                <img
                                    src={iconPreview}
                                    alt="Aperçu de l'icône"
                                    style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                                />
                            </div>
                        </div>
                    )}

                    {error && <p style={{ color: "red" }}>{error}</p>}

                    <button type="submit" disabled={loading}>
                        {loading ? "Envoi..." : secteurToUpdate ? "Modifier" : "Ajouter"}
                    </button>
                    <button type="button" onClick={onClose}>Annuler</button>
                </form>
            </div>
        </div>
    );
}